import * as React from 'react';
import { IArticleElements } from '../models/article-elements'
import { ArticleContent } from './article-content';
import { NewsContent } from './news-content';

interface IProps {
    items: IArticleElements[];
    currentPage: number;
    pageSize: number;
    newsListing: boolean;
}

export class ArticleContentList extends React.Component<IProps, any> {

    render() {
        const { items, currentPage, pageSize } = this.props;

        let currentMinimum = (currentPage - 1) * pageSize;
        let currentMaximum = currentPage * pageSize;

        let paginatedItems = items.slice(currentMinimum, currentMaximum) as IArticleElements[];

        return (
            <React.Fragment>
                {this.renderItems(paginatedItems)}
            </React.Fragment>
        );
    }

    renderItems = (paginatedItems: IArticleElements[]) => {
        if (this.props.newsListing) {
            return (
                <div className="paginated-news-listing-inner">
                    {paginatedItems.map((item, i) => <NewsContent content={item} key={i} />)}
                </div>
            );
        }

        return (
            <div className="article-listing-page-inner">
                {paginatedItems.map((item, i) => <ArticleContent content={item} key={i} />)}
            </div>
        );
    }
}





